import { ChatOverlayPreviewConfig, EmoteWallPreviewConfig } from 'components/overlayPreview/previewConfig'
import { CHAT_MESSAGE_WEIGHT_DEFAULT, CHAT_USERNAME_WEIGHT_DEFAULT } from 'lib/chatFonts'
import { DEFAULT_SAMPLE_SEED } from 'lib/overlaySamples'

export const SAMPLE_BADGES_ON: boolean = true
export const THIRD_PARTY_EMOTES_ON: boolean = false

export const HERO_CHAT_CONFIG: ChatOverlayPreviewConfig = {
  textShadow: 'SOFT',
  showTextShadow: true,
  showBadges: SAMPLE_BADGES_ON,
  showChannelPills: false,
  usernameFontSize: 15,
  usernameLineHeight: 22,
  messageFontSize: 15,
  messageLineHeight: 22,
  messageFontWeight: CHAT_MESSAGE_WEIGHT_DEFAULT,
  usernameFontWeight: CHAT_USERNAME_WEIGHT_DEFAULT,
  imageScale: 100,
  messageColor: '#EFEFF1',
  blockedWords: [],
  fontFamily: 'INTER',
  youtubeSourceEnabled: true,
  youtubeChatChannels: [],
  twitchChatChannels: [''],
  show7tvEmotes: THIRD_PARTY_EMOTES_ON,
  showBttvEmotes: THIRD_PARTY_EMOTES_ON,
  showFfzEmotes: THIRD_PARTY_EMOTES_ON,
  showYouTubeProfilePictures: false
}

export const HERO_WALL_CONFIG: EmoteWallPreviewConfig = {
  style: 'RAIN',
  emoteSize: 72,
  density: 16,
  durationSeconds: 7,
  showTwitchEmotes: true,
  show7tvEmotes: THIRD_PARTY_EMOTES_ON,
  showBttvEmotes: THIRD_PARTY_EMOTES_ON,
  showFfzEmotes: THIRD_PARTY_EMOTES_ON
}

export const DEMO_WALL_CONFIG: EmoteWallPreviewConfig = {
  style: 'RAIN',
  emoteSize: 56,
  density: 40,
  durationSeconds: 8,
  showTwitchEmotes: true,
  show7tvEmotes: THIRD_PARTY_EMOTES_ON,
  showBttvEmotes: THIRD_PARTY_EMOTES_ON,
  showFfzEmotes: THIRD_PARTY_EMOTES_ON
}

export const DEMO_FONT_KEYS = ['INTER', 'POPPINS', 'FREDOKA', 'VT323'] as const
export type DemoFontKey = typeof DEMO_FONT_KEYS[number]
export const DEMO_SHADOWS = ['OFF', 'SOFT', 'HARD'] as const
export type DemoShadow = typeof DEMO_SHADOWS[number]
export const DEMO_WALL_STYLES = ['RAIN', 'POP'] as const
export type DemoWallStyle = typeof DEMO_WALL_STYLES[number]

const LARGE_TEXT_FONTS: ReadonlySet<string> = new Set(['VT323'])

export const demoChatConfig = ({
  fontKey,
  shadow,
  badges
}: {
  fontKey: DemoFontKey
  shadow: DemoShadow
  badges: boolean
}): ChatOverlayPreviewConfig => {
  const large = LARGE_TEXT_FONTS.has(fontKey)
  return {
    ...HERO_CHAT_CONFIG,
    fontFamily: fontKey,
    textShadow: shadow,
    showTextShadow: shadow !== 'OFF',
    showBadges: SAMPLE_BADGES_ON && badges,
    usernameFontSize: large ? 20 : HERO_CHAT_CONFIG.usernameFontSize,
    usernameLineHeight: large ? 26 : HERO_CHAT_CONFIG.usernameLineHeight,
    messageFontSize: large ? 20 : HERO_CHAT_CONFIG.messageFontSize,
    messageLineHeight: large ? 26 : HERO_CHAT_CONFIG.messageLineHeight
  }
}

export const HERO_SEED = (DEFAULT_SAMPLE_SEED ^ 0x0101) >>> 0
export const DEMO_SEED = (DEFAULT_SAMPLE_SEED ^ 0x0202) >>> 0

export const SOON_POLL_STYLE = {
  headingTextColor: '#FFFFFF',
  headingBackground: 'linear-gradient(135deg, #1E3A8A 0%, #4338CA 100%)',
  optionsTextColor: '#FFFFFF',
  optionsBackground: 'linear-gradient(180deg, #2563EB 0%, #1D4ED8 100%)',
  callToActionTextColor: '#FFFFFF',
  callToActionBackground: 'linear-gradient(180deg, #1E1B4B 0%, #0F172A 100%)',
  optionTextColor: '#FFFFFF',
  optionProgressColor: '#67E8F9',
  cornerRadius: 16,
  borderWidth: 0,
  borderColor: '#00000000',
  winnerOutlineColor: '#67E8F9'
} as const
export const SOON_POLL_VOTES: readonly number[] = Object.freeze([620, 410, 210])
